import React, { memo, useEffect } from "react";
import { validators, formats } from "investira.sdk";
import {
  Stack,
  Divider,
  Typography,
  Card,
  CardHeader,
  CardContent,
} from "investira.react.components";
import ConsultaProvider from "../../../../contexts/ConsultaContext";
import useKickBack from "../../../../hooks/useKickBack";
import withMessage from "../../../../hoc/withMessage";
import PlanoPosicao from "../PlanoPosicao";
import DetalhesErrorMessage from "../DetalhesErrorMessage";
import Highlights from "./Highlights";
import DurationChart from "./DurationChart";
import Detalhes from "./Detalhes";
import Graphs from "./Graphs";

const ConsultaDuration = memo((props) => {
  const { data } = props;
  const kick = useKickBack();

  const ativosFiltered = (
    ativos = [],
    filtrarComErro = false,
    atributoErro = "erros"
  ) => {
    if (!Array.isArray(ativos)) return [];

    return ativos.filter((ativo) =>
      filtrarComErro
        ? ativo.hasOwnProperty(atributoErro)
        : !ativo.hasOwnProperty(atributoErro)
    );
  };

  useEffect(() => {
    kick && props.onMessage("Entidade alterada");
  }, [kick]);

  if (validators.isEmpty(data)) {
    return null;
  }

  const xAtivos = ativosFiltered(data.response.detalhe, false);
  const xAtivosError = ativosFiltered(data.response.detalhe, true);
  const xAtivosErrorSize = xAtivosError.length;
  const hasError = xAtivosErrorSize > 0;

  return (
    <ConsultaProvider>
      <Stack spacing={2}>
        <PlanoPosicao
          beta={false}
          created={data.request?.data}
          carteira={data.request_metadata?.carteira}
        />
        <Divider />

        <DetalhesErrorMessage show={hasError} ativosSize={xAtivosErrorSize} />
        <Stack
          sx={{ gap: 2 }}
          component="section"
          direction={{ xs: "column", md: "row" }}
        >
          <Stack
            sx={{
              flex: { xs: 1, sm: 1, md: 4, lg: 5, xl: 4 },
              minHeight: 0,
            }}
          >
            <Highlights data={data} />
          </Stack>
          <Stack
            sx={{
              flex: { xs: 1, sm: 1, md: 3, lg: 4, xl: 5 },
              minHeight: 0,
            }}
          >
            <Stack sx={{ gap: 2 }} component="section">
              <Graphs data={data} />
              {/* <Stack spacing={2}>
                <Card sx={{ height: "100%" }}>
                  <CardHeader title="Composição por Duration" />
                  <CardContent
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "100%",
                      minHeight: "200px",
                    }}
                  >
                    <Stack direction="row">
                      <Stack
                        flexGrow={1}
                        alignItems="center"
                        justifyContent="center"
                      >
                        <DurationChart
                          data={data.response.resumo.duration || []}
                        />
                      </Stack>
                    </Stack>
                  </CardContent>
                </Card>
              </Stack> */}
            </Stack>
          </Stack>
        </Stack>
        {data.request.juros_delta && (
          <Stack my={2}>
            <Typography variant="caption" color="textSecondary">
              "Sensibilidade" é a variação sofrida nos preços dos títulos caso
              ocorra alteração de{" "}
              {formats.formatNumber(data.request.juros_delta, 1, true, false)}%
              na taxa de juros.
            </Typography>
          </Stack>
        )}
        <Detalhes label="Ativos" detalhe={xAtivos || []} />
        <Detalhes label="Ativos Ignorados" detalhe={xAtivosError || []} />
      </Stack>
    </ConsultaProvider>
  );
});

export default withMessage(ConsultaDuration);
